export default __webpack_public_path__ + "static/media/login-background.ec3309be.jpg";